import React from 'react';
import { Box } from '@material-ui/core';

interface Props {
    audios: string[];
}

// Render list of HTML5 audio players (aligned with platform-v2), adapted to MUI v4
const ShowNoteAudios: React.FC<Props> = ({ audios }) => {
    if (!audios || audios.length === 0) return null;
    return (
        <Box style={{ display: 'grid', gap: 8, paddingLeft: 8, paddingRight: 8 }}>
            {audios.map((urlToDownload) => (
                <audio key={urlToDownload} controls src={urlToDownload} style={{ width: '100%', height: 40 }} />
            ))}
        </Box>
    );
};

export default ShowNoteAudios;
